import { CHANGECON_API } from '@/shared/config/api';
import { IMAGE_BASE } from '@/shared/config/image';
import { isHttpUrl } from './url';

export const NO_IMAGE = '/images/no_image.jpg';

export function isValidImageKey(key: string): boolean {
  if (key.startsWith(':') || key.startsWith('//')) return false;
  return !key.split('/').includes('..');
}

export function imageUrl(key: string | null | undefined): string {
  if (!key || !isValidImageKey(key)) return NO_IMAGE;
  return `${IMAGE_BASE}/${key}`;
}

const RELAYS: Record<string, string> = {
  'http://imgt.multicon.co.kr:9999': '/vendor-images/multicon',
};

export function safeSrc(url: string | null | undefined): string {
  if (!url || !isHttpUrl(url)) return NO_IMAGE;
  const { origin, pathname, search } = new URL(url);
  const relay = RELAYS[origin];
  return relay ? `${relay}${pathname}${search}` : url;
}

export function couponImageSrc(token: string): string {
  return `${CHANGECON_API}/coupons/${encodeURIComponent(token)}/image`;
}

export function productImageSrc(token: string | null, code: string): string | null {
  if (!token) return null;
  return `${CHANGECON_API}/coupons/${encodeURIComponent(token)}/products/${encodeURIComponent(code)}/image`;
}
